/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Core_Title4Inputs */

const en_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core loop first`)
};

const ar_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحلقة الأساسية أولا`)
};

const bn_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মূল লুপ আগে`)
};

const de_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kernschleife zuerst`)
};

const es_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El ciclo principal primero`)
};

const fr_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La boucle principale d'abord`)
};

const pt_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O ciclo principal primeiro`)
};

const zh_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核心链路先行`)
};

const tr_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Önce ana döngü`)
};

const ru_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главный цикл в первую очередь`)
};

const pl_svc_mvp_sprint_core_title4 = /** @type {(inputs: Svc_Mvp_Sprint_Core_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najpierw główna pętla`)
};

/**
* | output |
* | --- |
* | "Core loop first" |
*
* @param {Svc_Mvp_Sprint_Core_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_core_title4 = /** @type {((inputs?: Svc_Mvp_Sprint_Core_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Core_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_core_title4(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_core_title4(inputs)
	if (locale === "de") return de_svc_mvp_sprint_core_title4(inputs)
	if (locale === "es") return es_svc_mvp_sprint_core_title4(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_core_title4(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_core_title4(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_core_title4(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_core_title4(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_core_title4(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_core_title4(inputs)
	return en_svc_mvp_sprint_core_title4(inputs)
});
export { svc_mvp_sprint_core_title4 as "svc_mvp-sprint_CORE_title" }